import { render, staticRenderFns } from "./TheInscriptionForm.vue?vue&type=template&id=64bdc3dc&scoped=true"
import script from "./TheInscriptionForm.vue?vue&type=script&lang=js"
export * from "./TheInscriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bdc3dc",
  null
  
)

export default component.exports